<app-navbar></app-navbar>
<router-outlet></router-outlet>
<!-- <app-chat-bot *ngIf="isLoggedIn"></app-chat-bot> -->